export enum InputAccept {
  image = 'image/*',
  pdf = 'application/pdf',
}
